
import { http } from './index'

export async function getMyVacancies(params:any) {
    return await http.get<any>('/api/vacancy/created-by-me/', { params })
}

export async function confirmAssignation(id:string, userId: string) {
    const data = { user_id: userId }
    return await http.post<any>(`/api/vacancy/${id}/confirm-assignation/`, data)
}

export async function rejectAssignation(id:string, userId: string) {
    const data = { user_id: userId }
    return await http.post<any>(`/api/vacancy/${id}/reject-response/`, data)
}

export async function createVacancy(data:any) {
    return await http.post<any>(`/api/vacancy/`, data)
}

export async function createVacancyPack(data:any) {
    return await http.post<any>(`/api/vacancy/bulk-create/`, data)
}

export async function confirmVacancyPack() {
    return await http.post<any>(`/api/vacancy/bulk-confirm-first-responders/`)
}

export async function editVacancy(data:any) {
    return await http.put<any>(`/api/vacancy/${data.id}/`, data)
}

export async function deleteVacancy(id:string, data: any) {
    return await http.delete<any>(`/api/vacancy/${id}/`, { data })
}

export async function getSkills() {
    return await http.get<any>('/api/skill/')
}

export async function getMyDepartments(params:any) {
    return await http.get<any>('/api/departments/me/', {params})
}

export async function getError() {
    return await http.get<any>('/api/erorrrr/')
}

export async function getRequests(params:any) {
    return await http.get<any>('/api/vacancy/requests/', { params })
}

export async function requestReject(id:any) {
    return await http.patch<any>(`/api/vacancy/${id}/`, {is_request_rejected: true})
}

export async function getAvailableEmployees(data:any) {
    const { id, start, end } = data 
    
    return await http.get<any>(`/api/departments/${id}/available-employees`, {
        params: {
            dttm_work_start_at: start,
            dttm_work_end_at: end
        }
    })
}

export async function getVacancyArchive(params:any) {
    return await http.get<any>('/api/vacancy/archive/', { params })
}

export async function getOutsourceReport(data:any) {
    return await http.post<any>(`/api/report/outsource/`, data, {
        responseType: 'blob'
    })
}

export async function getVacancyHistory(id:string) {
    return await http.get<any>(`/api/vacancy/${id}/history/`)
}